var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-2 text-sm text-red-600",attrs:{"id":"email-error"}},[_vm._v(_vm._s(_vm.errors.join(' | ')))])}
var staticRenderFns = []

export { render, staticRenderFns }